import toastStore from '@/stores/toast-store.js'
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import { EventBus } from '@/event-bus.js'
import axios from 'axios'

export default {
  name: 'AddAppToHomeScreenModal',
  extends: BaseModal,
  data: function () {
    return {
      deferredPrompt: null,
      showInstallButton: true,
    }
  },
  mounted() {
    // INFO: `appinstalled` event is triggered immediately only after succesful instaliation
    window.addEventListener('appinstalled', evt => {
      toastStore.commit('success', {
        message: this.$t('addAppToHomeScreenModal.installSuccess'),
      })
      EventBus.$emit(`clearBeforeinstallprompt`) // For more info, search for `Clearing beforeinstallprompt event`

      let ua = window.navigator.userAgent
      let isFirefoxDesktop = /Firefox/i.test(ua)
      let isChromeDesktop = /Chrome/i.test(ua) && !/Android/i.test(ua)
      let isChromeAndroid = /Chrome/i.test(ua) && /Android/i.test(ua)

      let platform = ''
      if (isChromeAndroid) {
        platform = 'chrome-android'
      } else if (isChromeDesktop) {
        platform = 'chrome-desktop'
      } else if (isFirefoxDesktop) {
        platform = 'firefox-desktop'
      }

      this.updateUserActivity(platform, 'app_instalation', true)
      this.close(false)
    })
  },
  methods: {
    addToHomeScreen(e) {
      this.showInstallButton = false
      window.deferredPrompt.prompt()
      window.deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt')
        } else {
          console.log('User dismissed the A2HS prompt')
        }
        window.deferredPrompt = null
      })
    },

    updateUserActivity(platform, activity, activityValue) {
      const params = {
        userActivity: {
          platform: platform,
          activity: activity,
          activityValue: activityValue,
          metadata: {
            userAgent: window.navigator.userAgent,
          },
        },
      }

      axios({
        method: 'post',
        url: 'user_activities',
        data: params,
      })
        .then(response => {
          console.log('response', response)
        })
        .catch(error => {
          console.error('error updateUserActivity', error)
        })
    },

    registerUserDeclinedAppInstalation() {
      let ua = window.navigator.userAgent
      let isFirefoxDesktop = /Firefox/i.test(ua)
      let isChromeDesktop = /Chrome/i.test(ua) && !/Android/i.test(ua)
      let isChromeAndroid = /Chrome/i.test(ua) && /Android/i.test(ua)

      let platform = ''
      if (isChromeAndroid) {
        platform = 'chrome-android'
      } else if (isChromeDesktop) {
        platform = 'chrome-desktop'
      } else if (isFirefoxDesktop) {
        platform = 'firefox-desktop'
      }

      this.updateUserActivity(platform, 'app_instalation', false)
      this.close(false)
    },
  },
}
